import { IconButton as MuiIconButton, styled } from '@mui/material';
var IconButtonRoot = styled(MuiIconButton)({
    boxShadow: 'none',
});
var IconButton = IconButtonRoot;
export default IconButton;
